module.exports = __webpack_public_path__ + "img/skill_bgs.5674669f.png";